/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { gnoment } from 'shared-ui/gnoment';
import * as types from '../constants';

export function fetchAvailability(
    permitId,
    divisionId,
    startDate,
    endDate,
    commercialAccountFlag,
    isLottery,
    keyName = 'availability'
) {
    return (dispatch) => {
        return axios
            .get(
                `${process.env.API}/permits/${permitId}/divisions/${divisionId}/availability?start_date=${startDate.toISOString()}&end_date=${endDate.toISOString()}&commercial_acct=${!!commercialAccountFlag}&is_lottery=${!!isLottery}`
            )
            .then((success) => {
                let scale = 1;
                // Pere Marquette quotas need to be halved coming from the back end
                if (permitId === types.PERE_MARQUETTE_ID) {
                    scale = 0.5;
                }
                const avail = {};
                const secret = {};
                Object.keys(success.data.payload.date_availability).forEach((x) => {
                    avail[gnoment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] =
                        success.data.payload.date_availability[x].remaining > 0;
                    secret[gnoment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] =
                        success.data.payload.date_availability[x].is_secret_quota;
                });
                const availNums = {};
                Object.keys(success.data.payload.date_availability).forEach((x) => {
                    availNums[gnoment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] =
                        success.data.payload.date_availability[x].remaining * scale;
                });

                const quotaTypeMaps = success.data.payload.quota_type_maps;
                if (permitId === types.PERE_MARQUETTE_ID) {
                    Object.keys(quotaTypeMaps).forEach((key) => {
                        if (key === types.WATERCRAFT_AVAILABILITY_KEY_NAME) {
                            Object.keys(quotaTypeMaps[key]).forEach((date) => {
                                quotaTypeMaps[key][date].remaining *= scale;
                                quotaTypeMaps[key][date].total *= scale;
                            });
                        }
                    });
                }
                dispatch({
                    type: types.GET_AVAILABILITY,
                    keyName,
                    permitId,
                    divisionId,
                    payload: {
                        bools: avail,
                        nums: availNums,
                        secret,
                        quota_type_maps: quotaTypeMaps,
                    },
                });
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    dispatch({
                        type: types.GET_AVAILABILITY_ERROR,
                        keyName,
                        permitId,
                        divisionId,
                        payload: 'error while fetching data',
                        error: error.response.data,
                    });
                }
            });
    };
}

export function fetchAvailabilityAllDivisions({
    permitId,
    startDate,
    isLottery,
    commercialAccountFlag,
    addQuotaId,
}) {
    return (dispatch) => {
        const addQuotaIdQuery = addQuotaId ? `&add_quota_id=${addQuotaId}` : '';
        const startOfMonth = gnoment(startDate)
            .utc()
            .startOf('month')
            .startOf('day')
            .toISOString();
        return axios
            .get(
                `${process.env.API}/permits/${permitId}/availability/month?start_date=${startOfMonth}&commercial_acct=${!!commercialAccountFlag}&is_lottery=${!!isLottery}${addQuotaIdQuery}`
            )
            .then((success) => {
                let scale = 1;
                // Pere Marquette quotas need to be halved coming from the back end
                if (permitId === types.PERE_MARQUETTE_ID) {
                    scale = 0.5;
                }
                const availabilities = {};
                Object.keys(success.data.payload.availability).forEach((divisionId) => {
                    const divisionAvail = success.data.payload.availability[divisionId];
                    const bools = {};
                    const nums = {};
                    const secret = {};
                    Object.keys(divisionAvail.date_availability).forEach((x) => {
                        bools[gnoment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] =
                            divisionAvail.date_availability[x].remaining > 0;
                        nums[gnoment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] =
                            divisionAvail.date_availability[x].remaining * scale;
                        secret[gnoment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] =
                            divisionAvail.date_availability[x].is_secret_quota;
                    });

                    const quotaTypeMaps = divisionAvail.quota_type_maps;
                    if (permitId === types.PERE_MARQUETTE_ID) {
                        Object.keys(quotaTypeMaps).forEach((key) => {
                            if (key === types.WATERCRAFT_AVAILABILITY_KEY_NAME) {
                                Object.keys(quotaTypeMaps[key]).forEach((date) => {
                                    quotaTypeMaps[key][date].remaining *= scale;
                                    quotaTypeMaps[key][date].total *= scale;
                                });
                            }
                        });
                    }
                    const singleDivisionObj = {
                        divisionId,
                        permitId,
                        result: {
                            bools,
                            nums,
                            secret,
                            quota_type_maps: quotaTypeMaps,
                        },
                    };
                    availabilities[divisionId] = singleDivisionObj;
                });
                dispatch({ type: types.GET_ALL_AVAILABILITIES, payload: availabilities });
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    dispatch({
                        type: types.GET_ALL_AVAILABILITIES_ERROR,
                        payload: 'error while fetching data',
                        error: error.response.data,
                    });
                }
            });
    };
}

export function fetchNextAvailable(permitId) {
    return (dispatch) => {
        return axios
            .get(`${process.env.API}/permits/${permitId}/availability/nextavailable`)
            .then((success) => {
                dispatch({
                    type: types.GET_NEXT_AVAILABLE,
                    payload: success.data.payload,
                });
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    dispatch({
                        type: types.GET_NEXT_AVAILABLE_ERROR,
                        payload: 'error while fetching data',
                        error: error.response.data,
                    });
                }
            });
    };
}

export function clearAvailabilitiesMap() {
    return (dispatch) => {
        dispatch({ type: types.CLEAR_AVAILABILITIES, payload: {} });
    };
}
